const ROUTES = {
	SEARCH: "/search",
	VIEW_DOCUMENTS: "/view-documents",
	DOWNLOADS: "/downloads",
	BIFROST: "/bifrost",
	CASE_DETAILS: "/bifrost/case/:id",
	EXTRACT_DETAILS: "/bifrost/case/:caseId/text-extract/:jobId",
	PII_DETAILS: "/bifrost/case/:caseId/pii-extract/:jobId",
	REVERT_EXTRACT_DETAILS: "/bifrost/case/:caseId/revert-extract/:jobId",
	REVERT_PII_DETAILS: "/bifrost/case/:caseId/revert-pii-extract/:jobId",
	VIEWER_VIEW: "*/viewer/:fileId",
	UPLOAD_DETAILS: "/bifrost/case/:caseId/upload/:jobId",
	DASHBOARD: "/dashboard",
	USER: "/user",
	KBMAKING_DETAILS: "/bifrost/case/:caseId/kb-making/:jobId",
	BUILD_CONCEPTS: "/build-concept",
	TIMELINE: "/create-timeline",
	PAGE_NOT_FOUND: "/page-not-found",
	BILLING: "/billing",
	DEFAULT: "/",
	GENSUMMARY_DETAILS: "/bifrost/case/:caseId/job-details/:jobId",
	FORGOT_PASSWORD: "/forgot-password",
	RESET_PASSWORD: "/reset-password/:token",
}

export default ROUTES
